export interface PaymentMethodOption {
  value: string;
  label: string;
}

export interface PaymentMethodGroup {
  label: string;
  options: PaymentMethodOption[];
}

/** Valores y etiquetas originales del formulario genérico (Checkout 2). */
export const CHECKOUT2_PAYMENT_METHOD_GROUPS: PaymentMethodGroup[] = [
  {
    label: 'Oh',
    options: [
      { value: 'Oh-Visa', label: 'Oh-Visa | Tarjeta de Crédito Oh! Visa' },
      { value: 'Oh-Mastercard', label: 'Oh-Mastercard | Tarjeta de Crédito Oh! Mastercard' },
      { value: 'Tarjeta-Oh', label: 'Tarjeta-Oh | Tarjeta Oh! Visa y Mastercard' },
      { value: 'Tarjeta-Oh-Cuotas', label: 'Tarjeta Oh! Visa y Mastercard Cuota' },
      { value: 'Tarjeta-Oh-Visa', label: 'Tarjeta Oh Visa' },
      { value: 'Tarjeta-Oh-Mastercard', label: 'Tarjeta Oh Mastercard' },
      { value: 'Tarjeta Oh!', label: 'Tarjeta Oh!' },
    ],
  },
  {
    label: 'Agora',
    options: [
      { value: 'Tarjeta-Agora-Visa', label: 'Tarjeta Prepago Agora Visa' },
      { value: 'Agora-Visa', label: 'Tarjeta Agora Visa / Débito Sip' },
      { value: 'AGORAWEB', label: 'AGORAWEB | App Sip' },
      { value: 'AGORA', label: 'AGORA | Crédito y Débito Agora Shop' },
      { value: 'AGORA-UNIFICADO', label: 'Agora unificado' },
    ],
  },
  {
    label: 'Interbank',
    options: [
      { value: 'Tarjetas-Interbank-VIVANDA', label: 'Tarjetas INTERBANK - VIVANDA' },
      { value: 'Tarjetas-IBK-Visa', label: 'Tarjetas IBK Visa' },
      { value: 'Tarjetas-IBK-Mastercard', label: 'Tarjetas IBK Mastercard' },
      { value: 'Tarjetas-IBK-Amex', label: 'Tarjetas IBK Amex' },
      { value: 'Tarjetas-INTERBANK', label: 'Tarjetas INTERBANK' },
    ],
  },
  {
    label: 'Banners / retail',
    options: [
      { value: 'Tarjetas-Amex-VIVANDA', label: 'Tarjetas AMEX - VIVANDA' },
      { value: 'Tarjetas-Credito-Debito-VIVANDA', label: 'Crédito o Débito - VIVANDA' },
      { value: 'Tarjetas-Credito-Debito-OECHSLE', label: 'Crédito o Débito - OECHSLE' },
      { value: 'Tarjetas-Credito-Debito-PVEA', label: 'Crédito o Débito - PLAZA VEA' },
      { value: 'Tarjetas-Credito-Debito-PROMART', label: 'Crédito o Débito - PROMART' },
      { value: 'Tarjetas-Credito-Debito-PROM', label: 'Tarjetas-Credito-Debito-PROM' },
      { value: 'Campana-Peru-Pasion', label: 'Campaña Perú Pasión' },
    ],
  },
  {
    label: 'Tarjetas generales',
    options: [
      { value: 'Tarjetas-Credito', label: 'Tarjeta de Crédito' },
      { value: 'Tarjetas-Debito', label: 'Tarjeta de Débito' },
      { value: 'Credito-Intercorp', label: 'Crédito Intercorp' },
      { value: 'Debito-Intercorp', label: 'Débito Intercorp' },
      { value: 'Tarjetas-Visa', label: 'Tarjetas Visa' },
      { value: 'Tarjetas-Mastercard', label: 'Tarjetas Mastercard' },
      { value: 'Tarjetas-Amex', label: 'Tarjetas Amex' },
      { value: 'Tarjetas-Diners', label: 'Tarjetas Diners' },
      { value: 'Tarjetas-Credito-Debito', label: 'Tarjetas de Crédito o Débito' },
    ],
  },
];
